import React from 'react';

const Loading = () => {
  return (
    <div>
      <div className="spinner"></div>
      <div className="preloader"></div>
      {/* <h1>Loading</h1> */}
    </div>
  );
};

export default Loading;
